import { PICS_URL } from "api";
import AddOrLinkButton from "components/AddOrLinkButton";
import InputSelect from "components/InputSelect";
import Counter2 from "components/counter2";
import CalculatorPackichQuote from "components/quote/packich_quote";
import { useStores } from "hooks/useStores";
import { format_price } from "js/utils";
import React, { useEffect, useRef, useState } from "react";
import Price from './components/Price';

const SpecialTape = () => {
  const [count, setCount] = useState(1);
  const [countPacks, setCountPacks] = useState(1);
  const [isLoaded, setIsLoaded] = useState(false);
  const [isFetchedAdd, setIsFetchedAdd] = useState(false);
  const [items, setItems] = useState({});
  const [fetch, setFetch] = useState(1);
  const [type, setType] = useState(1);
  const [width, setWidth] = useState(1);
  const [defaultWidth, setDefaultWidth] = useState(1);
  const [length, setLength] = useState(1);
  const [defaultLength, setDefaultLength] = useState(1);

  const { api } = useStores();

  useEffect(() => {
    setIsLoaded(false);
    api.catalog
      .getSpecialTapeCalc({
        tape_type: type,
        width: width,
        length: length,
      })
      .then((response) => {
        setItems(response);
        for (let item of response.width) {
          if (item.is_active === true) {
            setDefaultWidth(item);
          }
        }
        for (let item of response.length) {
          if (item.is_active === true) {
            setDefaultLength(item);
          }
        }
        setIsLoaded(true);
      });
  }, [fetch]);

  const widthHandler = (value) => {
    setWidth(value.value);
    setCount(items.multiplicity);
    setCountPacks(1);
    setFetch(fetch + 1);
    restartButton();
  };

  const lengthHandler = (value) => {
    setLength(value.value);
    setCount(items.multiplicity);
    setCountPacks(1);
    setFetch(fetch + 1);
    restartButton();
  };

  useEffect(() => {
    if (isLoaded) {
      for (let item of items.tape_type) {
        if (item.is_active === true) {
          document.querySelector(".calc-right__title").innerHTML = item.label;
        }
      }
    }
  }, [isLoaded]);

  const radioHandler = (e) => {
    for (let i = 0; i < items.tape_type.length; i++) {
      const item = items.tape_type[i];
      const radio = document.querySelector(`#radio-${i + 1}`);
      if (e.target.id === `radio-${i + 1}` && type === item.value) {
        return;
      }
      if (radio.checked === true) {
        setType(item.value);
        setCount(items.multiplicity);
        setCountPacks(1);
        setFetch(fetch + 1);
      }
    }
    restartButton();
  };

  useEffect(() => {
    if (isLoaded) {
      for (let i = 0; i < items.tape_type.length; i++) {
        const item = items.tape_type[i];
        if (item.is_active === true) {
          document.querySelector(`#radio-${i + 1}`).checked = true;
        }
      }
    }
  }, [isLoaded]);

  const resetHandler = () => {
    document.querySelector("#radio-1").checked = true;
    setCount(items.multiplicity);
    setCountPacks(1);
    setType(1);
    setWidth(1);
    setLength(1);
    setFetch(fetch + 1);
    setIsAdd(false);
  };

  const restartButton = () => {
    setIsAdd(false);
  };

  useEffect(() => {
    if (isLoaded) {
      setCount(items.multiplicity);
    }
  }, [isLoaded]);

  const [isLoadedCounters, setIsLoadedCounters] = useState(false);
  const [restartCounters, setRestartCounters] = useState(1);

  useEffect(() => {
    setIsLoadedCounters(true);
  }, [restartCounters]);

  const countRef = useRef(true);
  useEffect(() => {
    if (countRef.current) {
      // do componentDidMount logic
      countRef.current = false;
    } else {
      // do componentDidUpdate logic
      if (count === 0) {
        setCount(items.multiplicity);
        return;
      }
      if (count / items.in_pack_count === countPacks) {
        return;
      }
      setCountPacks(Math.ceil(count / items.in_pack_count));
      setIsLoadedCounters(false);
      setRestartCounters(restartCounters + 1);
    }
  }, [count]);

  const countPackRef = useRef(true);
  useEffect(() => {
    if (countPackRef.current) {
      // do componentDidMount logic
      countPackRef.current = false;
    } else {
      // do componentDidUpdate logic
      setCount(countPacks * items.in_pack_count);
      setIsLoadedCounters(false);
      setRestartCounters(restartCounters + 1);
    }
  }, [countPacks]);

  const [isAdd, setIsAdd] = useState(false);
  const postItem = () => {
    setIsFetchedAdd(true);

    api.cart
      .postCartItem({
        product_article: items.article,
        item_quantity: count,
        package_quantity: countPacks,
      })
      .then(() => changeBasketCount())
      .finally(() => {
        setIsFetchedAdd(false);
        setIsAdd(true);
      });
  };

  const changeBasketCount = () => {
    api.cart
      .getCartItems()
      .then((response) => {
        let counters = document.querySelectorAll(".basket-counter");
        for (let counter of counters) {
          counter.innerText = String(response.length);
        }
      })
      .catch((error) => {
        if (error.response.status === 500) {
        }
      });
  };

  const [minPrice, setMinPrice] = useState();
  const [maxPrice, setMaxPrice] = useState();
  useEffect(() => {
    if (isLoaded) {
      setMinPrice(format_price(items.min_price));
      setMaxPrice(format_price(items.max_price));
    }
  }, [isLoaded]);

  let slideIndex = 1;
  function showSlides(slideIndex) {
    let sliderSize = document.querySelector(".how-gallery-slider").clientWidth;
    const slides = document.querySelectorAll(
      ".how-gallery-slider__slides-item"
    );
    for (let slide of slides) {
      slide.style.transform = `translateX(-${(slideIndex - 1) * sliderSize}px)`;
    }

    const dots = document.querySelectorAll(".controls-dots-dot");
    for (let dot of dots) {
      dot.classList.remove("controls-dots-dot-active");
    }
    dots[slideIndex - 1].classList.add("controls-dots-dot-active");
  }

  useEffect(() => {
      if (document.querySelectorAll(".controls-dots-dot").length !== 0) {
        const dots = document.querySelectorAll(".controls-dots-dot");
        if (dots.length === 1) {
          document.querySelector(
            ".how-gallery-slider__controls"
          ).style.display = "none";
        }
        dots[0].classList.add("controls-dots-dot-active");
        for (let i = 0; i < dots.length; i++) {
          const dot = dots[i];
          dot.addEventListener("click", () => {
            slideIndex = i + 1;
            showSlides(slideIndex);
          });
        }
        let backBtn = document.querySelector("#backBtn");
        backBtn.addEventListener("click", back);
        let frvBtn = document.querySelector("#frvBtn");
        frvBtn.addEventListener("click", frv);
      }
  }, []);

  const back = () => {
      const dots = document.querySelectorAll(".controls-dots-dot");
      if (slideIndex === 1) {
        slideIndex = dots.length;
      } else {
        slideIndex -= 1;
      }
      showSlides(slideIndex);
  };

  const frv = () => {
      const dots = document.querySelectorAll(".controls-dots-dot");
      if (slideIndex === dots.length) {
        slideIndex = 1;
      } else {
        slideIndex += 1;
      }
      showSlides(slideIndex);
  };
  return (
    <div className='calculator-main-content-calc'>
      <div className='calc-setings'>
        <div className='calc-settings-wrap'>
          <ul className='calc-settings__list'>
            <li className='calc-settings__list-item'>
              <p className='calc-settings__list-item-title radio-title'>Вид:</p>
              <div className='calc-settings__list-item-setting radio-settings-wrap'>
                <div className='radio-settings'>
                  {isLoaded ? (
                    items.tape_type.map((item, i) => (
                      <div key={i} className='form_radio'>
                        <input
                          id={"radio-" + (i + 1)}
                          type='radio'
                          name='radio'
                          value='1'
                          onClick={(e) => radioHandler(e)}
                        />
                        <label htmlFor={"radio-" + (i + 1)}>{item.label}</label>
                      </div>
                    ))
                  ) : (
                    <>
                      {[...Array(7)].map((el, i) => (
                        <div key={i} className='radio-loader' />
                      ))}
                    </>
                  )}
                </div>
              </div>
            </li>
            <li className='calc-settings__list-item'>
              <p className='calc-settings__list-item-title'>Длина, м:</p>
              <div className='calc-settings__list-item-setting'>
                {isLoaded ? (
                  <InputSelect
                    defaultValue={defaultLength}
                    options={items.length}
                    onchangeInput={lengthHandler}
                  />
                ) : (
                  <div className='input-loader' />
                )}
              </div>
            </li>
            <li className='calc-settings__list-item'>
              <p className='calc-settings__list-item-title'>Ширина, мм:</p>
              <div className='calc-settings__list-item-setting'>
                {isLoaded ? (
                  <InputSelect
                    defaultValue={defaultWidth}
                    options={items.width}
                    onchangeInput={widthHandler}
                  />
                ) : (
                  <div className='input-loader' />
                )}
              </div>
            </li>
            {!isLoaded || items.in_pack_count === 1 ? null : (
              <li className='calc-settings__list-item'>
                <p className='calc-settings__list-item-title'>
                  {items.page_data.package_count_text !== ""
                    ? items.page_data.package_count_text
                    : "Количество, уп:"}
                </p>
                {isLoadedCounters ? (
                  <Counter2
                    id={"counter1"}
                    onChange={setCountPacks}
                    count={countPacks}
                    multiplicity={items.multiplicity}
                    packages={true}
                    minCount={1}
                    step={1}
                    restart={restartButton}
                  />
                ) : null}
              </li>
            )}
            {!isLoaded ? null : (
              <li className='calc-settings__list-item'>
                <p className='calc-settings__list-item-title'>
                  {items.page_data.count_text !== ""
                    ? items.page_data.count_text
                    : "Количество, шт:"}
                  {items.in_pack_count === 1 ? null : (
                    <span className='tooltip'>
                      <span className='tooltiptext'>
                        {items.page_data.package_count_hint !== ""
                          ? items.page_data.package_count_hint
                          : `1 упаковка = ${items.in_pack_count} штук(и)`}
                      </span>
                    </span>
                  )}
                </p>
                {isLoadedCounters ? (
                  <Counter2
                    id={"counter2"}
                    onChange={setCount}
                    count={count}
                    minCount={items.multiplicity}
                    multiplicity={items.multiplicity}
                    step={items.multiplicity}
                    restart={restartButton}
                  />
                ) : null}
              </li>
            )}
            <li className='calc-settings__list-item mobile-list-item'>
              <p className='calc-settings__list-item-title'>Наличие:</p>
              {items.in_stock == "в наличии" ||
              items.in_stock == "В наличии" ? (
                <div className='calc-settings__list-item-setting settings-stock'>
                  {items.in_stock}
                </div>
              ) : (
                <div className='calc-settings__list-item-setting settings-outOfStock'>
                  {items.in_stock}
                </div>
              )}
            </li>
            <Price minPrice={minPrice} maxPrice={maxPrice} />

            <li className='calc-settings__list-item calc-border'>
              <div className='calc-settings-border'></div>
            </li>
            <li className='calc-settings__list-item calc-cart'>
              <button
                className='calc-settings__button-reset'
                onClick={resetHandler}
              >
                <div className='button-reset-icon'></div>
                <div className='button-reset-title'>Сбросить</div>
              </button>
              <AddOrLinkButton
                isAdd={isAdd}
                postItem={postItem}
                isFetchedAdd={isFetchedAdd}
              />
            </li>
          </ul>
        </div>
      </div>
      <div className='calc-right'>
        <div className='calc-right__content'>
          {items.image ? (
            <div className='calc-right__img'>
              <img loading="lazy" src={PICS_URL + items.image} alt={items.title || ''} />
            </div>
          ) : null}
          <h3 className='calc-right__title'>Специальные ленты</h3>
          <table className='calc-right__table'>
            <tbody>
              <tr>
                <th>Артикул</th>
                <td>{items.article}</td>
              </tr>
              <tr>
                <th>Техническое название</th>
                <td>{items.title}</td>
              </tr>
            </tbody>
          </table>
          {items?.page_data?.pak_pakych_quote ? (
            <CalculatorPackichQuote
              text={items.page_data.pak_pakych_quote.text}
              bgColor={items.page_data.pak_pakych_quote.bg_color}
              borderColor={items.page_data.pak_pakych_quote.border_color}
            />
          ) : null}
        </div>
      </div>
    </div>
  );
};

export default SpecialTape;
